import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        'default': 'bg-primary text-primary-foreground hover:bg-primary/90',
        'snack-cta': 'bg-softBlack text-white hover:bg-primary/90 font-700 text-sm font-inter font-700',
        'snack': 'bg-softBlack text-white hover:bg-primary/90 font-700 text-xs font-inter font-700 ',
        'snack-outline':
          'border border-softGray bg-none hover:bg-softBlack hover:text-white',
        'destructive':
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        'outline':
          'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        'secondary':
          'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        'ghost': 'hover:bg-accent hover:text-accent-foreground',
        'snack-ghost': 'text-darkGray hover:bg-grayLighter hover:text-softBlack',
        'snack-icon-cube-rounded': 'text-softBlack hover:bg-grayLighter hover:text-softBlack !rounded-[6px] bg-white',
        'snack-icon': 'text-softBlack hover:bg-grayLighter hover:text-softBlack rounded-full bg-white rounded-full',
        'link': 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        'default': 'h-10 px-4 py-2',
        'no-padding': 'h-10',
        'sm': 'h-9 rounded-md px-3',
        'lg': 'h-11 rounded-md px-8',
        'icon': 'h-10 w-10',
        'icon-sm': 'h-5 w-5',
        'icon-snack': 'w-6 h-6',
      },
      icon: {
        default: '[&_svg]:w-5 [&_svg]:h-5',
        lg: '[&_svg]:w-6 [&_svg]:h-6',
        sm: '[&_svg]:w-4 [&_svg]:h-4',
        xs: '[&_svg]:w-3 [&_svg]:h-3',

      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      icon: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
